/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddUserDto,
  AskPasswordUpdateDto,
  BindUserToOauth2ServerDoneDto,
  CancelDeleteUserDto,
  ConfirmDeleteUserDto,
  DeleteUserDto,
  ResetPasswordDto,
  SetRolesDto,
  SetUserLanguageDto,
  UpdateUserInformationsDto,
  UserId,
  UserOperationResponseResource,
  UserResource,
} from '../models';
import {
    AddUserDtoFromJSON,
    AddUserDtoToJSON,
    AskPasswordUpdateDtoFromJSON,
    AskPasswordUpdateDtoToJSON,
    BindUserToOauth2ServerDoneDtoFromJSON,
    BindUserToOauth2ServerDoneDtoToJSON,
    CancelDeleteUserDtoFromJSON,
    CancelDeleteUserDtoToJSON,
    ConfirmDeleteUserDtoFromJSON,
    ConfirmDeleteUserDtoToJSON,
    DeleteUserDtoFromJSON,
    DeleteUserDtoToJSON,
    ResetPasswordDtoFromJSON,
    ResetPasswordDtoToJSON,
    SetRolesDtoFromJSON,
    SetRolesDtoToJSON,
    SetUserLanguageDtoFromJSON,
    SetUserLanguageDtoToJSON,
    UpdateUserInformationsDtoFromJSON,
    UpdateUserInformationsDtoToJSON,
    UserIdFromJSON,
    UserIdToJSON,
    UserOperationResponseResourceFromJSON,
    UserOperationResponseResourceToJSON,
    UserResourceFromJSON,
    UserResourceToJSON,
} from '../models';

export interface DeleteRequest {
    deleteUserDto: DeleteUserDto;
    async?: boolean;
}

export interface AddRequest {
    addUserDto: AddUserDto;
    async?: boolean;
}

export interface BindDoneRequest {
    bindUserToOauth2ServerDoneDto: BindUserToOauth2ServerDoneDto;
    async?: boolean;
}

export interface CancelDeleteRequest {
    cancelDeleteUserDto: CancelDeleteUserDto;
    async?: boolean;
}

export interface ConfirmDeleteRequest {
    confirmDeleteUserDto: ConfirmDeleteUserDto;
    async?: boolean;
}

export interface FindAll2Request {
    organizationId?: string;
    showDeleted?: boolean;
}

export interface FindOneRequest {
    id: string;
}

export interface ResetPasswordRequest {
    resetPasswordDto: ResetPasswordDto;
    async?: boolean;
}

export interface SaveAllUserRolesRequest {
    id: string;
    setRolesDto: SetRolesDto;
    async?: boolean;
}

export interface SetAskPasswordUpdateRequest {
    askPasswordUpdateDto: AskPasswordUpdateDto;
    async?: boolean;
}

export interface SetUserLanguageRequest {
    setUserLanguageDto: SetUserLanguageDto;
    async?: boolean;
}

export interface UpdateRequest {
    updateUserInformationsDto: UpdateUserInformationsDto;
    async?: boolean;
}

export interface ValidateRequest {
    id: string;
    async?: boolean;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * ${user.command.controller.operation.delete.description}
     * ${user.command.controller.operation.delete.summary}
     */
    async _deleteRaw(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.deleteUserDto === null || requestParameters.deleteUserDto === undefined) {
            throw new runtime.RequiredError('deleteUserDto','Required parameter requestParameters.deleteUserDto was null or undefined when calling _delete.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteUserDtoToJSON(requestParameters.deleteUserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.delete.description}
     * ${user.command.controller.operation.delete.summary}
     */
    async _delete(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this._deleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.add.description}
     * ${user.command.controller.operation.add.summary}
     */
    async addRaw(requestParameters: AddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.addUserDto === null || requestParameters.addUserDto === undefined) {
            throw new runtime.RequiredError('addUserDto','Required parameter requestParameters.addUserDto was null or undefined when calling add.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddUserDtoToJSON(requestParameters.addUserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.add.description}
     * ${user.command.controller.operation.add.summary}
     */
    async add(requestParameters: AddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.addRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.bindDone.description}
     * ${user.command.controller.operation.bindDone.summary}
     */
    async bindDoneRaw(requestParameters: BindDoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.bindUserToOauth2ServerDoneDto === null || requestParameters.bindUserToOauth2ServerDoneDto === undefined) {
            throw new runtime.RequiredError('bindUserToOauth2ServerDoneDto','Required parameter requestParameters.bindUserToOauth2ServerDoneDto was null or undefined when calling bindDone.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/user/bind-to-auth-server-done`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BindUserToOauth2ServerDoneDtoToJSON(requestParameters.bindUserToOauth2ServerDoneDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.bindDone.description}
     * ${user.command.controller.operation.bindDone.summary}
     */
    async bindDone(requestParameters: BindDoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.bindDoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.cancelDelete.description}
     * ${user.command.controller.operation.cancelDelete.summary}
     */
    async cancelDeleteRaw(requestParameters: CancelDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.cancelDeleteUserDto === null || requestParameters.cancelDeleteUserDto === undefined) {
            throw new runtime.RequiredError('cancelDeleteUserDto','Required parameter requestParameters.cancelDeleteUserDto was null or undefined when calling cancelDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/cancelDelete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelDeleteUserDtoToJSON(requestParameters.cancelDeleteUserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.cancelDelete.description}
     * ${user.command.controller.operation.cancelDelete.summary}
     */
    async cancelDelete(requestParameters: CancelDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.cancelDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.confirmDelete.description}
     * ${user.command.controller.operation.confirmDelete.summary}
     */
    async confirmDeleteRaw(requestParameters: ConfirmDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.confirmDeleteUserDto === null || requestParameters.confirmDeleteUserDto === undefined) {
            throw new runtime.RequiredError('confirmDeleteUserDto','Required parameter requestParameters.confirmDeleteUserDto was null or undefined when calling confirmDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/confirmDelete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmDeleteUserDtoToJSON(requestParameters.confirmDeleteUserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.confirmDelete.description}
     * ${user.command.controller.operation.confirmDelete.summary}
     */
    async confirmDelete(requestParameters: ConfirmDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.confirmDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${group.command.controller.operation.findAll.description}
     * ${user.command.controller.operation.findAll.summary}
     */
    async findAll2Raw(requestParameters: FindAll2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserResource>>> {
        const queryParameters: any = {};

        if (requestParameters.organizationId !== undefined) {
            queryParameters['organizationId'] = requestParameters.organizationId;
        }

        if (requestParameters.showDeleted !== undefined) {
            queryParameters['showDeleted'] = requestParameters.showDeleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserResourceFromJSON));
    }

    /**
     * ${group.command.controller.operation.findAll.description}
     * ${user.command.controller.operation.findAll.summary}
     */
    async findAll2(requestParameters: FindAll2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserResource>> {
        const response = await this.findAll2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${group.command.controller.operation.findOne.description}
     * ${user.command.controller.operation.findOne.summary}
     */
    async findOneRaw(requestParameters: FindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResource>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOne.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResourceFromJSON(jsonValue));
    }

    /**
     * ${group.command.controller.operation.findOne.description}
     * ${user.command.controller.operation.findOne.summary}
     */
    async findOne(requestParameters: FindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResource> {
        const response = await this.findOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.resetPassword.description}
     * ${user.command.controller.operation.resetPassword.summary}
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.resetPasswordDto === null || requestParameters.resetPasswordDto === undefined) {
            throw new runtime.RequiredError('resetPasswordDto','Required parameter requestParameters.resetPasswordDto was null or undefined when calling resetPassword.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/resetPassword`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordDtoToJSON(requestParameters.resetPasswordDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.resetPassword.description}
     * ${user.command.controller.operation.resetPassword.summary}
     */
    async resetPassword(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.resetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.saveAllUserRoles.description}
     * ${user.command.controller.operation.saveAllUserRoles.summary}
     */
    async saveAllUserRolesRaw(requestParameters: SaveAllUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling saveAllUserRoles.');
        }

        if (requestParameters.setRolesDto === null || requestParameters.setRolesDto === undefined) {
            throw new runtime.RequiredError('setRolesDto','Required parameter requestParameters.setRolesDto was null or undefined when calling saveAllUserRoles.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/roles/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetRolesDtoToJSON(requestParameters.setRolesDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.saveAllUserRoles.description}
     * ${user.command.controller.operation.saveAllUserRoles.summary}
     */
    async saveAllUserRoles(requestParameters: SaveAllUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.saveAllUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.setAskPasswordUpdate.description}
     * ${user.command.controller.operation.setAskPasswordUpdate.summary}
     */
    async setAskPasswordUpdateRaw(requestParameters: SetAskPasswordUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.askPasswordUpdateDto === null || requestParameters.askPasswordUpdateDto === undefined) {
            throw new runtime.RequiredError('askPasswordUpdateDto','Required parameter requestParameters.askPasswordUpdateDto was null or undefined when calling setAskPasswordUpdate.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/askPasswordUpdate`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AskPasswordUpdateDtoToJSON(requestParameters.askPasswordUpdateDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.setAskPasswordUpdate.description}
     * ${user.command.controller.operation.setAskPasswordUpdate.summary}
     */
    async setAskPasswordUpdate(requestParameters: SetAskPasswordUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.setAskPasswordUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.setUserLanguage.description}
     * ${user.command.controller.operation.setUserLanguage.summary}
     */
    async setUserLanguageRaw(requestParameters: SetUserLanguageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.setUserLanguageDto === null || requestParameters.setUserLanguageDto === undefined) {
            throw new runtime.RequiredError('setUserLanguageDto','Required parameter requestParameters.setUserLanguageDto was null or undefined when calling setUserLanguage.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/setLanguage`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserLanguageDtoToJSON(requestParameters.setUserLanguageDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.setUserLanguage.description}
     * ${user.command.controller.operation.setUserLanguage.summary}
     */
    async setUserLanguage(requestParameters: SetUserLanguageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.setUserLanguageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.command.controller.operation.update.description}
     * ${user.command.controller.operation.update.summary}
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserOperationResponseResource>> {
        if (requestParameters.updateUserInformationsDto === null || requestParameters.updateUserInformationsDto === undefined) {
            throw new runtime.RequiredError('updateUserInformationsDto','Required parameter requestParameters.updateUserInformationsDto was null or undefined when calling update.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/admin/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserInformationsDtoToJSON(requestParameters.updateUserInformationsDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserOperationResponseResourceFromJSON(jsonValue));
    }

    /**
     * ${user.command.controller.operation.update.description}
     * ${user.command.controller.operation.update.summary}
     */
    async update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserOperationResponseResource> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ${user.admin-command.controller.operation.validate.description}
     * ${user.admin-command.controller.operation.validate.summary}
     */
    async validateRaw(requestParameters: ValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserId>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling validate.');
        }

        const queryParameters: any = {};

        if (requestParameters.async !== undefined) {
            queryParameters['async'] = requestParameters.async;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/admin/{id}/validate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserIdFromJSON(jsonValue));
    }

    /**
     * ${user.admin-command.controller.operation.validate.description}
     * ${user.admin-command.controller.operation.validate.summary}
     */
    async validate(requestParameters: ValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserId> {
        const response = await this.validateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
